// derived from code by https://gist.github.com/fresheneesz
// original code: https://gist.github.com/alediaferia/cfb3a7503039f9278381#gistcomment-1851167
import { EventEmitter } from 'events'

// file - The file to read from
// options - Possible options:
//   type - (Default: "Text") Can be "Text" or "ArrayBuffer" ("DataURL" is unsupported at the moment - dunno how to concatenate dataUrls
//   chunkSize - (Default: 64K) The number of bytes to get chunks of
// Returns an EventEmitter that emits the following events:
//     data(data) - Returns a chunk of data
//     error(error) - Returns an error. If this event happens, reading of the file stops (no end event will happen).
//     end() - Indicates that the file is done and there's no more data to read
// derivedfrom here http://stackoverflow.com/questions/14438187/javascript-filereader-parsing-long-file-in-chunks
export default function read(file, options) {
    var emitter = new EventEmitter()

    if(options === undefined) options = {}
    if(options.type === undefined) options.type = "ArrayBuffer"
    if(options.chunkSize === undefined) options.chunkSize = 64000

    var offset = 0, method = 'readAs'+options.type//, dataUrlPreambleLength = "data:;base64,".length

    var onLoadHandler = function(evt) {
        if(evt.target.error !== null) {
            emitter.emit('error', evt.target.error)
            return;
        }

        var data = evt.target.result

        offset += options.chunkSize
        emitter.emit('data', data)
        if (offset >= file.size) {
            emitter.emit('end')
        } else {
            readChunk(offset, options.chunkSize, file)
        }
    }

    var readChunk = function(_offset, length, _file) {
        var r = new FileReader()
        var blob = _file.slice(_offset, length + _offset)
        r.onload = onLoadHandler
        r[method](blob)
    }

    readChunk(offset, options.chunkSize, file)

    return emitter
}



// WEBPACK FOOTER //
// ./src/lib/chunks-file-reader.js